import { SelectField, SelectFieldProps } from 'components/form/final-form'
import { CategoriaArquivoAtendProfEnum } from 'graphql/types.generated'
import React from 'react'

import { categoriaAnexoLabelRecord, CategoriaArquivoSelectModel } from '../model-anexoArquivos'

type CategoriaArquivoSelectFieldProps = Omit<SelectFieldProps<CategoriaArquivoSelectModel>, 'items' | 'itemToString'>

export function CategoriaArquivoSelectField(props: CategoriaArquivoSelectFieldProps) {
  return <SelectField<CategoriaArquivoSelectModel> itemToString={itemToString} items={items} {...props} />
}

const items = Object.values(CategoriaArquivoAtendProfEnum)
const itemToString = (item: CategoriaArquivoSelectModel) => item && categoriaAnexoLabelRecord[item]
